import React from 'react';
import { Control, FieldValues, FieldPath } from 'react-hook-form';

import ImageUploader from '@ts-core/core/components/ImageUploader';

import { useExerciseMediaField } from '../../hooks';

import ExerciseMediaItemsList from '../ExerciseMediaItemsList';

interface ExerciseMediaFieldProps<TField extends FieldValues> {
  control: Control<TField, any>;

  name: FieldPath<TField>;
}

const ExerciseMediaField = <TField extends FieldValues>(props: ExerciseMediaFieldProps<TField>) => {
  const { control, name } = props;

  const { mediaItems, onDeleteMediaAtIndex, acceptedFiles, onFiledSelected, onSortMedia, selectedFileName, uploadError, uploadProgress, uploading } =
    useExerciseMediaField({ control, name });

  return (
    <ImageUploader
      acceptedFiles={acceptedFiles}
      onFileSelected={onFiledSelected}
      selectedFileName={selectedFileName}
      uploading={uploading}
      uploadError={uploadError}
      progress={uploadProgress}
    >
      <ExerciseMediaItemsList sx={{ mt: 2 }} items={mediaItems} onRemoveItemAtIndex={onDeleteMediaAtIndex} onSortMedia={onSortMedia} />
    </ImageUploader>
  );
};

export default ExerciseMediaField;
